import { Metadata, resolveDateRange } from '@dx-ui/dx-common';
import useSetupUsage, {
  SetupUsage,
} from '@dx-ui/dx-common/src/utils/useSetupUsage';
import {
  createColumnsContract,
  createColumnsDeliveryLocation,
  createColumnsDespatchAdvice,
  createColumnsOrder,
  createColumnsProcessDetails,
  createColumnsReceiptAdvice,
  createColumnsTotals,
  createCommonColumns,
  createCommonFilters,
  createContractFilters,
  createDeliveryLocationFilters,
  createDespatchAdviceFilters,
  createOrderFilters,
  createProcessDetailsFilters,
  createReceiptAdviceFilters,
  createSpecificColumnsReceiptAdvice,
  createSpecificReceiptAdviceFilters,
  createTotalsFilters,
} from '../../aspects';
import { CommonList, DisplayContextualButtons } from '../../shared';

/**
 * Declare the additional columns to display
 */
const columns: any[] = [
  ...createCommonColumns(),
  ...createColumnsDeliveryLocation(),
  ...createColumnsDespatchAdvice(),
  ...createColumnsTotals(),
  ...createColumnsContract(),
  ...createColumnsOrder(),
  ...createColumnsProcessDetails(),
  ...createColumnsReceiptAdvice(),
  ...createSpecificColumnsReceiptAdvice(),
];

/**
 * Specific filters
 */
const additionalFilters: any[] = [
  ...createCommonFilters(),
  ...createDeliveryLocationFilters(),
  ...createDespatchAdviceFilters(),
  ...createTotalsFilters(),
  ...createContractFilters(),
  ...createOrderFilters(),
  ...createProcessDetailsFilters(),
  ...createReceiptAdviceFilters(),
  ...createSpecificReceiptAdviceFilters(),
];

/**
 * @param {*} props
 */
const ReceiptAdviceList = (props) => {
  const setupUsage: SetupUsage | undefined = useSetupUsage();
  const isDemoSetup: boolean = setupUsage === SetupUsage.DEMO;
  return (
    <CommonList
      title='dxMessages.receiptAdvices.title'
      {...props}
      columns={columns}
      additionalFilters={additionalFilters}
      contextualToolbar={<DisplayContextualButtons />}
      filterDefaultValues={
        isDemoSetup
          ? {}
          : {
              [Metadata.created]: resolveDateRange({
                predefinedRange: 'last-7-days',
              }),
            }
      }
    />
  );
};

export default ReceiptAdviceList;
